import { useState, useEffect } from "react";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import { cloneDeep } from "lodash";
import TkInsertStandardUnitPriceExcelUploadDialog from "../dialogTypes/TkInsertStandardUnitPriceExcelUploadDialog"

function TkInsertStandardUnitPriceExcelUploadButton ( props ) {

    const { id, schema, refresh, onSuccess, createButtonName, customizeErrorMsgCallback, modifyUrlCallback, ...others } = props;

    const [ open, setOpen ] = useState(false);

    const [modifiySchema, setModifiedSchema] = useState();

    useEffect(()=>{

        if(schema) {

            let modifiedSchema = cloneDeep(schema);

            for(let column of modifiedSchema.columns) {

                switch (column.name) {

                    case "excelFile" :

                        column.hideInForm = false;

                    break;

                    default :
                        column.hideInForm = true;
                    break;

                }
            }

            setModifiedSchema(modifiedSchema);

        }

    },[schema])

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        if ( refresh ) {

            refresh.refresh ();

        }

    };

    
    return (

        <>
            <CreateRecordButtonLayout id={id+"excelUpload-button"} onClick={onOpen} createButtonName ={createButtonName} {...others} />
            <TkInsertStandardUnitPriceExcelUploadDialog
                id={id+"excelUpload-dialog"}
                formId={id+"create-form"}
                schema={modifiySchema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>

    );
}

export default TkInsertStandardUnitPriceExcelUploadButton;

